var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":""}},[_c('div',{staticClass:"logo-wrapper"},[_c('h1',[_c('em',[_vm._v("A")]),_c('em',[_vm._v("V")]),_c('em',[_vm._v("I")]),_c('em',[_vm._v("S")]),_c('em',{staticClass:"planet left"}),_c('em',[_vm._v("L")]),_c('em',[_vm._v("A")]),_c('em',[_vm._v("R")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }